import { AppliedSearchTags } from '@/features/invoices/components/List/AppliedSearchTags';
import { useReceivedInvoiceSearchQuery } from '@/features/invoices/components/List/Table/hook';
import { useReceivedInvoicesFormInitial } from '@/features/invoices/components/List/hooks';
import { ReconciliationOfficeSettingProvider } from '@/features/invoices/hooks/useReconciliationStatusVisible';
import { useRenewalUiReceivedInvoicesFlag } from '@/hooks/feature_flag/useRenewalUiReceivedInvoicesFlag';
import {
  List,
  ReceivedInvoiceSearch,
} from '@features/invoices/components/List';
import classNames from 'classnames/bind';
import { FC, memo, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const TemplateInvoiceListInner: FC = memo(() => {
  const defaultValues = useReceivedInvoicesFormInitial();
  const [isTriggeredSearch, setIsTriggeredSearch] = useState(false);
  const [isPolling, setIsPolling] = useState(false);
  const flagRenewalUiReceivedInvoices = useRenewalUiReceivedInvoicesFlag();

  const { searchQuery, handleSearch } =
    useReceivedInvoiceSearchQuery(defaultValues);

  return (
    <div
      className={cx(
        styles['container'],
        flagRenewalUiReceivedInvoices
          ? styles['container-renewal']
          : styles['container-padded']
      )}
    >
      <ReceivedInvoiceSearch
        defaultValues={defaultValues}
        onSearch={handleSearch}
        setIsTriggeredSearch={setIsTriggeredSearch}
        isPolling={isPolling}
      />
      <AppliedSearchTags searchQuery={searchQuery} />
      <List
        className={cx({
          [styles['list-padded']]: flagRenewalUiReceivedInvoices,
        })}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        isTriggeredSearch={isTriggeredSearch}
        setIsTriggeredSearch={setIsTriggeredSearch}
        setIsPolling={setIsPolling}
      />
    </div>
  );
});

TemplateInvoiceListInner.displayName = 'TemplateInvoiceListInner';

export const TemplateInvoiceList: FC = memo(() => (
  <ReconciliationOfficeSettingProvider>
    <TemplateInvoiceListInner />
  </ReconciliationOfficeSettingProvider>
));

TemplateInvoiceList.displayName = 'TemplateInvoiceList';
